import { Component, Input, Output, EventEmitter } from '@angular/core';

import { indexOf } from 'lodash';

import { CheckboxTypesEnum } from '../../../../Common/Forms/enums/checkbox-types.enum';
import { NetworkTypeEnum, networkOptionsOrder as networkOrder } from '../../enums/network-type.enum';
import { NetworkOption } from '../../../Shared/components/NetworkRadio/network-radio.component';
import { ControlValueAccessorModel, getProvider } from '../../../../Common/Forms/models/control-value-accessor.model';
import { MediaTypeEnum, mediaTypeIconMap } from '../../../../Common/Basic/enums/media-type.enum';

@Component({
    selector: 'agpr-network-multi-select',
    templateUrl: './network-multi-select.component.html',
    styleUrls: ['./network-multi-select.component.scss'],
    providers: [
        getProvider(NetworkMultiSelectComponent)
    ],
    standalone: false
})
export class NetworkMultiSelectComponent extends ControlValueAccessorModel<NetworkTypeEnum[]> {

    /** Network options that can be displayed, usually based on user perms */
    @Input() set allowedNetworks(validNetworks: NetworkTypeEnum[]) {
        this.networkOptions = this.allOptions.filter(network => validNetworks.includes(network.type));
        this.networkOptions.sort((a, b) => indexOf(networkOrder, a.type) - indexOf(networkOrder, b.type));
    }

    @Input() set unavailableNetworks(noPermissionNetworks: NetworkTypeEnum[]) {
        this.unavailableNetworkOptions = this.allOptions.filter(network => noPermissionNetworks.includes(network.type));
        this.unavailableNetworkOptions.sort((a, b) => indexOf(networkOrder, a.type) - indexOf(networkOrder, b.type));
        noPermissionNetworks.forEach(net => {
            if (!this.unavailableNetworkValue.includes(net)) {
                this.unavailableNetworkValue.push(net);
            }
        });
    }

    @Input() heading: string;
    @Input() ariaDescribedBy: string;
    @Input() allDisabledExceptTwitter: boolean = false;

    @Output() blur: EventEmitter<FocusEvent> = new EventEmitter();
    @Input() set partiallyModeratedNetworks(networks: NetworkTypeEnum[]) {
        this.isNetworkModerated(networks, this.networkOptions);
    }

    value: NetworkTypeEnum[] = [];
    unavailableNetworkValue: NetworkTypeEnum[] = [];

    readonly checkboxTypesEnum = CheckboxTypesEnum;
    readonly networkTypeEnum = NetworkTypeEnum;
    readonly allOptions: NetworkOption[] = [
        {
            type: NetworkTypeEnum.twitter,
            icon: mediaTypeIconMap.get(MediaTypeEnum.TWITTER),
            tooltip: `MediaType.${MediaTypeEnum.TWITTER}`
        },
        {
            type: NetworkTypeEnum.facebook,
            icon: mediaTypeIconMap.get(MediaTypeEnum.FACEBOOK),
            tooltip: `MediaType.${MediaTypeEnum.FACEBOOK}`
        },
        {
            type: NetworkTypeEnum.instagram,
            icon: mediaTypeIconMap.get(MediaTypeEnum.INSTAGRAM),
            tooltip: `MediaType.${MediaTypeEnum.INSTAGRAM}`
        },
        {
            type: NetworkTypeEnum.youtube,
            icon: mediaTypeIconMap.get(MediaTypeEnum.YOUTUBE),
            tooltip: `MediaType.${MediaTypeEnum.YOUTUBE}`
        },
        {
            type: NetworkTypeEnum.reddit,
            icon: mediaTypeIconMap.get(MediaTypeEnum.REDDIT),
            tooltip: `MediaType.${MediaTypeEnum.REDDIT}`
        },
        {
            type: NetworkTypeEnum.tiktok,
            icon: mediaTypeIconMap.get(MediaTypeEnum.TIKTOK),
            tooltip: `MediaType.${MediaTypeEnum.TIKTOK}`
        },
        {
            type: NetworkTypeEnum.linkedin,
            icon: mediaTypeIconMap.get(MediaTypeEnum.LINKEDIN),
            tooltip: `MediaType.${MediaTypeEnum.LINKEDIN}`
        },
        {
            type: NetworkTypeEnum.bluesky,
            icon: mediaTypeIconMap.get(MediaTypeEnum.BLUESKY),
            tooltip: `MediaType.${MediaTypeEnum.BLUESKY}`
        },
    ];

    networkOptions: NetworkOption[] = this.allOptions;
    unavailableNetworkOptions: NetworkOption[] = [];

    constructor() {
        super();
    }

    onBlur(event: FocusEvent) {
        this.onModelTouched();
        this.blur.emit(event);
    }

    isNetworkModerated(moderatedNetworks: NetworkTypeEnum[], networkOptions: NetworkOption[]) {
        if (moderatedNetworks) {
            networkOptions.forEach(option => {
                if (moderatedNetworks.includes(option.type)) {
                    option.isPartiallyModerated = true;
                } else {
                    option.isPartiallyModerated = false;
                }
            });

        }
    }
}
